export default __webpack_public_path__ + "static/media/iconBateria.771ccd93.svg";